var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNoSearchResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 75,
    viewBox: "0 0 118 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9412 10.8553V13.3153L66.3494 12.8132L116 2.46006V59.9286L108.433 61.3916L106.813 61.7049V63.3553V71.0668L97.5381 64.3049L96.8231 63.7837L95.9566 63.9621L54.263 72.5463V64.3421V61.8931L51.8633 62.3824L2 72.551V15.2476L63.9412 2.45525V10.8553Z",
    stroke: "url(#paint0_linear_785_10610)",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33H45.6818V43H35V33Z",
    fill: "url(#paint1_linear_785_10610)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6591 33H64.3409V43H53.6591V33Z",
    fill: "url(#paint2_linear_785_10610)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3182 33H83V43H72.3182V33Z",
    fill: "url(#paint3_linear_785_10610)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_785_10610",
    x1: 109.986,
    y1: 90.3557,
    x2: 53.3421,
    y2: 27.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#F02826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_785_10610",
    x1: 59,
    y1: 28,
    x2: 123.07,
    y2: 60.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_785_10610",
    x1: 59,
    y1: 28,
    x2: 123.07,
    y2: 60.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_785_10610",
    x1: 59,
    y1: 28,
    x2: 123.07,
    y2: 60.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9532"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoSearchResult);
export default __webpack_public_path__ + "static/media/IconNoSearchResult.5aafdbf98de6781ea9e509a99af85126.svg";
export { ForwardRef as ReactComponent };